import React, { useState } from 'react';
import { Typography, Container, Paper, Grid } from '@mui/material';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css'; // Import the Lightbox styles
import Zoom from 'yet-another-react-lightbox/plugins/zoom'; // Import the Zoom plugin
import { useTranslation } from 'react-i18next'; // Import useTranslation hook
import './App.css';

const CommercialStores = () => {
  const { t, i18n } = useTranslation(); // Use the useTranslation hook
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [loadingStates, setLoadingStates] = useState({}); // Track loading state for each image

  const images = [
    { src: '/images/Redjane photoshooting-12.jpg' },
    { src: '/images/Redjane photoshooting-8.jpg' },
    { src: '/images/RedjaneUse2.JPG' },
    { src: '/images/Redjanephotoshooting-1.jpg' },
    { src: '/images/Redjane photoshooting-55.jpg' },
    { src: '/images/Redjane photoshooting-45.jpg' },
    { src: '/images/Redjane photoshooting-13.jpg' },
    { src: '/images/Redjane photoshooting-26.jpg' },
    { src: '/images/Redjane photoshooting-37.jpg' },
    { src: '/images/Redjane photoshooting-52.jpg' },
    { src: '/images/Redjane photoshooting-43.jpg' },
    { src: '/images/Redjane photoshooting-19.jpg' },
  ];

  const handleImageLoad = (index) => {
    setLoadingStates((prevState) => ({ ...prevState, [index]: false }));
  };

  const handleImageError = (index) => {
    setLoadingStates((prevState) => ({ ...prevState, [index]: false }));
  };

  return (
    <>
      <Container maxWidth="xl" style={{ padding: '20px', marginTop: '-20px' }}>
        <Paper elevation={3} className="home-paper">
          <Typography
            variant="h6"
            style={{
              color: '#576a89',
              textAlign: 'left',
              marginBottom: '0px',
            }}
          >
            {t('Red Jane Bakery')}
          </Typography>
          <Typography
            variant="h6"
            style={{
              color: '#576a89',
              textAlign: 'left',
              marginBottom: '0px',
            }}
          >
            {t('Designer: Michael Anastassiades')}
          </Typography>
          <Typography
            variant="h6"
            style={{
              color: '#576a89',
              textAlign: 'left',
              marginBottom: '0px',
            }}
          >
            {t('Located in Center Town, Chania, Greece')}
          </Typography>

          <Grid container spacing={4} style={{ marginTop: '0px' }}>
            {images.map((image, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <div style={{ position: 'relative', width: '100%', height: '300px' }}>
                  {loadingStates[index] !== false && (
                    <div
                      className="loader"
                      style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                      }}
                    >
                      <div className="spinner"></div>
                    </div>
                  )}
                  <img
                    className="fancy-image"
                    src={image.src}
                    alt={`OtherImage ${index + 1}`}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      transition: 'transform 0.3s ease-in-out',
                      display: loadingStates[index] === false ? 'block' : 'none',
                      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                    }}
                    onClick={() => {
                      setPhotoIndex(index);
                      setLightboxOpen(true);
                    }}
                    onLoad={() => handleImageLoad(index)}
                    onError={() => handleImageError(index)}
                  />
                </div>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Container>

      {/* Lightbox component */}
      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        slides={images}
        index={photoIndex}
        plugins={[Zoom]} // Add the Zoom plugin here
        zoom={{ maxZoomPixelRatio: 3, scrollToZoom: true }}
      />

      {/* Return to portfolio link */}
      <a href={`/portfolio?lang=${i18n.language}`} className="return-to-portfolio-button">
        {t('Return to Portfolio')}
      </a>
    </>
  );
};

export default CommercialStores;